import {
  Navigate,
} from 'react-router-dom';

import UrlEnums from '@/components/connections/enums/UrlEnums';
import Login from '@/screens/auth/Login';
import SignUp from '@/screens/auth/SignUp';
import Logout from '@/screens/auth/Logout';
import NotFoundPage from '@/screens/NotFoundPage';
import Home from '@/screens/Home';
import Profile from '@/screens/users/Profile';
import ForgotPassword from '@/screens/auth/ForgetPassword';
import ResetPassword from '@/screens/auth/ResetPassword';
import Verify from '@/screens/auth/Verify';
import Showcase from '@/screens/hacktoberfest/Showcase';
import CompanyList from '@/screens/companies/CompanyList';
import CompanyForm from '@/screens/companies/CompanyForm';
import CompanyDetail from '@/screens/companies/CompanyDetail';
import CustomerForm from '@/screens/customers/CustomerForm';
import InvoiceForm from '@/screens/invoices/InvoiceForm';

const routes = [
  {
    path: UrlEnums.MAIN,
    element: <Home />,
    type: 'authenticated',
  },
  { path: UrlEnums.PROFILE, element: <Profile />, type: 'authenticated' },
  { path: UrlEnums.LOGOUT, element: <Logout />, type: 'authenticated' },
  { path: UrlEnums.LOGIN, element: <Login />, type: 'public' },
  { path: UrlEnums.SIGN_UP, element: <SignUp />, type: 'public' },
  { path: UrlEnums.PASSWORD_FORGET, element: <ForgotPassword />, type: 'public' },
  { path: UrlEnums.PASSWORD_RESET, element: <ResetPassword />, type: 'public' },
  { path: UrlEnums.VERIFY, element: <Verify />, type: 'public' },
  { path: UrlEnums.SHOWCASE, element: <Showcase /> },

  // Companies
  { path: UrlEnums.COMPANIES, element: <CompanyList />, type: 'authenticated' },
  { path: UrlEnums.COMPANY_CREATE, element: <CompanyForm />, type: 'authenticated' },
  { path: UrlEnums.COMPANY_DETAIL, element: <CompanyDetail />, type: 'authenticated' },
  { path: UrlEnums.COMPANY_EDIT, element: <Navigate to=".." replace />, type: 'authenticated' },
  { path: UrlEnums.COMPANY_SETTINGS, element: <Navigate to=".." replace />, type: 'authenticated' },

  // Customers (sub-resource forms only — list lives inside CompanyDetail tabs)
  { path: UrlEnums.CUSTOMERS, element: <Navigate to=".." replace />, type: 'authenticated' },
  { path: UrlEnums.CUSTOMER_CREATE, element: <CustomerForm />, type: 'authenticated' },
  { path: UrlEnums.CUSTOMER_EDIT, element: <CustomerForm />, type: 'authenticated' },

  // Invoices (sub-resource forms only — list lives inside CompanyDetail tabs)
  { path: UrlEnums.INVOICES, element: <Navigate to=".." replace />, type: 'authenticated' },
  { path: UrlEnums.INVOICE_CREATE, element: <InvoiceForm />, type: 'authenticated' },
  { path: UrlEnums.INVOICE_EDIT, element: <InvoiceForm />, type: 'authenticated' },

  { path: UrlEnums.NOT_FOUND, element: <NotFoundPage /> },
  { path: '*', element: <Navigate to={UrlEnums.NOT_FOUND} replace /> },
];

export default routes;
